import http from "@/utils/request";

class ChannelApi {
  listChannel(data) {
    return http.sendRequest({
      METHOD_NAME: "channel.listChannel",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    });
  }

  addOrModifyChannel(data) {
    return http.sendRequest({
      METHOD_NAME: "channel.addOrModifyChannel",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    });
  }

  deleteChannel(data) {
    return http.sendRequest({
      METHOD_NAME: "channel.deleteChannel",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    });
  }
}

export default new ChannelApi();
